export default class Map {
  constructor(el) {
    this.el = el;
    this.init();
  }

  init() {
    this.initMap();
    this.fetchLocations();
  }

  initMap() {
    const google = window.google;
    var infowindow = new google.maps.InfoWindow();
    var locations = this.fetchLocations();

    // Focus map on first location in array (if no locations --> Fallback to Ghent)
    var lat = locations[0]?.latitude ?? 51.049009;
    var long = locations[0]?.longitude ?? 3.684922;

    const mapElement = document.querySelector("#map");

    var map = null;

    if (mapElement.classList.contains("map-full")) {
      map = new google.maps.Map(mapElement, {
        center: { lat: 51.068094, lng: 4.043343 },
        zoom: 8,
      });
    }
    else {
      map = new google.maps.Map(mapElement, {
        center: { lat: lat, lng: long },
        zoom: 12,
      });
    }

    var marker, i;

    for (i = 0; i < locations.length; i++) {
      const icon = {
        url: locations[i].markerUrl,
        scaledSize: new google.maps.Size(40, 40)
      };

      marker = new google.maps.Marker({
        position: new google.maps.LatLng(locations[i].latitude, locations[i].longitude),
        map: map,
        icon: icon,
      });

      var contentString = `
      <div class="c-map__info">
        <div class="location">
          <span class="title">${locations[i].name}</span>
          <p>${locations[i].street}</p>
          <p>${locations[i].postalcode} ${locations[i].city}</p>
          <a href="${locations[i].mapsurl}" target="_blank">
            <i class="fa fa-solid fa-arrow-right" aria-hidden="true"></i> ${locations[i].mapslink}
          </a>
        </div>
        <div class="contact">
      `;

      if(locations[i].email !== "") {
        contentString += `
        <div class="u-clear"><p class="highlight">${locations[i].dictMail}</p>
        <a href="mailto:${locations[i].email}">${locations[i].email}</a></div>
        `
      }

      if(locations[i].phone !== "") {
        contentString += `
        <div class="u-clear"><p class="highlight">${locations[i].dictPhone}</p>
        <p>${locations[i].phone}</p></div>
        `
      }

      contentString += `
        </div>
      </div>
      `;

      marker.contentString = contentString;
      
      // Automaticaly open the info card of the first marker (remove this if unwanted)
      if (!mapElement.classList.contains("map-full")) {
        if(i === 0){
          infowindow.setContent(contentString);
          infowindow.open(map, marker);
        } 
      }

      google.maps.event.addListener(
        marker, "click", (function (marker, i) {
          return function () {
            infowindow.setContent(this.contentString);
            infowindow.open(map, marker);
          };
        })(marker, i)
      );
    }
  }

  fetchLocations() {
    const locationsString = document.getElementById("map-wide").getAttribute("locations");
    const locations = JSON.parse(locationsString.replace(/'/g, '"'));

    return locations;
  }
}
